import React, { FC, useEffect, useState, ReactNode } from 'react';
import { initTransifexWithFallback } from '@raisin/translations-backup';
import { getTMSFormat } from '@raisin/cp-utils';

interface Props {
  locale: string;
  children: ReactNode;
}

const tx = initTransifexWithFallback({
  token: process.env.NEXT_PUBLIC_TRANSIFEX_NATIVE_TOKEN,
  filterTags: 'postbox',
});

export const TranslationProvider: FC<Props> = ({ children, locale }) => {
  const [isLocaleAvailable, setLocale] = useState(false);

  useEffect(() => {
    async function loadLocale() {
      try {
        await tx.setCurrentLocale(getTMSFormat(locale));
      } catch (error) {
        console.warn(error);
      } finally {
        setLocale(true);
      }
    }
    loadLocale();
  }, [locale]);

  return <>{isLocaleAvailable && children}</>;
};
